module.exports = __webpack_public_path__ + "img/sx.0de23b6c.svg";